import r from "./td-longtail-vue-components168.js";
/* empty css                              */
import o from "./td-longtail-vue-components98.js";
var s = function() {
  var a = this, t = a._self._c, e = a._self._setupProxy;
  return a.pages && a.pages.length > 1 ? t("nav", { ref: "carouselNavigationElement", staticClass: "carousel-navigation", class: {
    "carousel-navigation--page-hidden": a.hidePages,
    "carousel-navigation--justify-mobile": a.hidePagesMobile
  }, attrs: { role: "navigation", "aria-label": a.ariaLabel.replace("%d", a.pages.length.toString()) } }, [t(e.ForwardBackwardButton, { staticClass: "carousel-navigation__button carousel-navigation__button--previous", attrs: { "aria-label": a.labelPrev, disabled: e.activePage?.number === 0 && !a.infinity, primary: a.primary, secondary: a.secondary }, on: { clicked: e.clickPrev } }), a.hidePages ? a._e() : t("ul", { staticClass: "carousel-navigation__container", class: { "carousel-navigation__container--hide-pages-mobile": a.hidePagesMobile } }, a._l(a.pages, function(i, n) {
    return t("li", { key: n, staticClass: "carousel-navigation__entry" }, [t(e.LinkButton, { staticClass: "carousel-navigation__link", class: { "carousel-navigation__link--active": i.active }, attrs: { tag: "button", type: "button", "icon-only": "", outline: "", "aria-label": e.ariaLabelForPageNumber(a.pages, i), "aria-current": i.active ? "page" : void 0 }, on: { click: function(_) {
      return a.$emit("update", i.number);
    } } })], 1);
  }), 0), t(e.ForwardBackwardButton, { staticClass: "carousel-navigation__button carousel-navigation__button--next", attrs: { direction: "right", "aria-label": a.labelNext, disabled: e.activePage?.number === a.pages.length - 1 && !a.infinity, primary: a.primary, secondary: a.secondary }, on: { clicked: e.clickNext } })], 1) : a._e();
}, l = [], c = /* @__PURE__ */ o(
  r,
  s,
  l,
  !1,
  null,
  "270b1422"
);
const b = c.exports;
export {
  b as default
};
